import getCharts from '../getCharts'
import {FetchServiceLocations}  from '../../constants/api.config'

export default async function syncServiceLocationFromKareo( Mode="" ) {
  try {
    const payload = { Mode }
    const res = await getCharts(FetchServiceLocations, payload)
    return res.data
  } catch (error) {
    return error
  }
}
